/* FSD26 urgency clocks (2026-09-23). Ticks every [data-fsd-urg] on the page from its data-end (ISO 8601 with
   tz offset). One shared interval; safe to load twice. When a clock has run out it hides itself instead of
   sitting at 0d 00h 00m 00s while the midnight theme swap catches up. */
(function () {
  if (window.__fsdUrg) return; window.__fsdUrg = true;
  function z(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var nodes = document.querySelectorAll('[data-fsd-urg]');
    for (var i = 0; i < nodes.length; i++) {
      var r = nodes[i], e = Date.parse(r.getAttribute('data-end'));
      if (isNaN(e)) continue;
      var rem = e - Date.now();
      if (rem <= 0) { r.setAttribute('data-over', '1'); continue; }
      var x = Math.floor(rem / 1000), D = Math.floor(x / 86400); x -= D * 86400;
      var H = Math.floor(x / 3600); x -= H * 3600; var M = Math.floor(x / 60); x -= M * 60;
      var d = r.querySelector('[data-d]'), h = r.querySelector('[data-h]'), m = r.querySelector('[data-m]'), s = r.querySelector('[data-s]');
      if (d) d.textContent = D; if (h) h.textContent = z(H); if (m) m.textContent = z(M); if (s) s.textContent = z(x);
      r.setAttribute('data-live', '1');
    }
  }
  tick(); setInterval(tick, 1000);
  document.addEventListener('shopify:section:load', tick);
})();
